import component from './PhDeviceTabletCamera.vue_vue_type_script_lang.vue.js';
export { default } from './PhDeviceTabletCamera.vue_vue_type_script_lang.vue.js';
import { render } from './PhDeviceTabletCamera.vue_vue_type_template_id_1a745f19_lang.vue.js';

component.render = render;
